import Icon from './icon';

export default class Spinner extends Icon {
	public static override observedAttributes = [...Icon.observedAttributes, 'spin'];

	public set spin(value: boolean) {
		if (this.#spin === value) {
			return;
		}
		this.#spin = value;
		this.#spinChanged = true;
		this.invalidateProperties();
	}

	public get spin(): boolean {
		return this.#spin;
	}

	#animation!: Animation;
	#keyframes!: Keyframe[];
	#options!: KeyframeAnimationOptions;
	#spin: boolean;
	#spinChanged: boolean;

	private get animation(): Animation {
		if (!this.#animation) {
			this.#animation = this.animate(this.keyFrames, this.options);
		}
		return this.#animation;
	}

	private get keyFrames(): Keyframe[] {
		if (!this.#keyframes) {
			this.#keyframes = [{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }];
		}
		return this.#keyframes;
	}

	private get options(): KeyframeAnimationOptions {
		if (!this.#options) {
			this.#options = {
				duration: 800,
				easing: 'linear',
				iterations: Infinity,
			};
		}
		return this.#options;
	}

	public constructor() {
		super();
		this.#spin = false;
		this.#spinChanged = false;
		this.name = 'refresh-cw-04';
		this.width = 28;
		this.height = 28;
	}

	protected override attributeChangedCallback(name: string, _: string, value: string) {
		super.attributeChangedCallback(name, _, value);
		if (name === 'spin') {
			this.#spinAttributeChanged(value);
		}
	}

	protected override commitProperties(): void {
		super.commitProperties();
		if (this.#spinChanged) {
			this.#commitSpin();
		}
	}

	#commitSpin(): void {
		this.#spinChanged = false;
		if (this.#spin) {
			this.animation.play();
		} else {
			// cancelled rather than paused, so the icon comes to rest upright: pausing leaves the
			// rotation where it stopped, which is a tilted icon for anything that is not round
			this.animation.cancel();
		}
	}

	#spinAttributeChanged(value: string): void {
		this.spin = value === 'true';
	}
}
customElements.define('ac-spinner', Spinner);
